export const shipmentStatusList = [
  {
    value: 'RPC',
    text: 'Request Pickup',
    number: 100,
    next: [200],
  },
  {
    value: 'ASG',
    text: 'Assign to Firsmile',
    number: 200,
    next: [300],
  },
  {
    value: 'RTP',
    text: 'Ready to pickup',
    number: 300,
    next: [400],
  },
  {
    value: 'COL',
    text: 'Courier on pickup location',
    number: 400,
    next: [410, 420],
  },
  {
    value: 'PAPV',
    text: 'Package Approved',
    number: 410,
    next: [500],
  },
  {
    value: 'PRJL',
    text: 'Package Rejected',
    number: 420,
    next: [],
  },
  {
    value: 'POL',
    text: 'Package on origin locker',
    number: 500,
    next: [600],
  },
  {
    value: 'ODL',
    text: 'Package on destination locker',
    number: 600,
    next: [700],
  },
  {
    value: 'ASGLM',
    text: 'Assign to Lastmile',
    number: 700,
    next: [800],
  },
  {
    value: 'PDP',
    text: 'Package ready to deliver or to destination locker',
    number: 800,
    next: [900],
  },
  {
    value: 'POD',
    text: 'Package on delivery to receiver',
    number: 900,
    next: [1000],
  },
  {
    value: 'COD',
    text: 'Courier on destination',
    number: 1000,
    next: [2000, 3000],
  },
  {
    value: 'PDO',
    text: 'Package Dropoff',
    number: 2000,
    next: [],
  },
  {
    value: 'UNDLM',
    text: 'Undelivered',
    number: 3000,
    next: [4000],
  },
  {
    value: 'UNDPAHLM',
    text: 'Undevlivered in Admin Hub',
    number: 4000,
    next: [700, 5000],
  },
  {
    value: 'HAPH',
    text: 'Hold On Admin Hub',
    number: 5000,
    next: [],
  },
];
export const shipmentBatchStatusList = [
  {
    value: 'RPC',
    text: 'Request Pickup',
    number: 100,
    next: [200],
  },
  {
    value: 'ASG',
    text: 'Assign to Firsmile',
    number: 200,
    next: [300],
  },
  {
    value: 'RTP',
    text: 'Ready to pickup',
    number: 300,
    next: [400],
  },
  {
    value: 'COL',
    text: 'Courier on pickup location',
    number: 400,
    next: [410, 420, 430],
  },
  {
    value: 'PAPV',
    text: 'Package Approved',
    number: 410,
    next: [500],
  },
  {
    value: 'PRJL',
    text: 'Package Rejected',
    number: 420,
    next: [],
  },
  {
    value: 'RAP',
    text: 'Reattempt Pickup',
    number: 430,
    next: [200],
  },
  {
    value: 'POL',
    text: 'Package on origin locker',
    number: 500,
    next: [600],
  },
  {
    value: 'ODL',
    text: 'Package on destination locker',
    number: 600,
    next: [700],
  },
  {
    value: 'ASGLM',
    text: 'Assign to Lastmile',
    number: 700,
    next: [800],
  },
  {
    value: 'PDP',
    text: 'Package ready to deliver or to destination locker',
    number: 800,
    next: [900],
  },
  {
    value: 'POD',
    text: 'Package on delivery to receiver',
    number: 900,
    next: [1000],
  },
  {
    value: 'COD',
    text: 'Courier on destination',
    number: 1000,
    next: [2000, 3000],
  },
  {
    value: 'PDO',
    text: 'Package Dropoff',
    number: 2000,
    next: [],
  },
  {
    value: 'UNDLM',
    text: 'Undelivered',
    number: 3000,
    next: [4000],
  },
  {
    value: 'UNDPAHLM',
    text: 'Undevlivered in Admin Hub',
    number: 4000,
    next: [700, 5000],
  },
  {
    value: 'HAPH',
    text: 'Hold On Admin Hub',
    number: 5000,
    next: [6000, 7000],
  },
  {
    value: 'DSP',
    text: 'Shipment Disposed',
    number: 6000,
    next: [],
  },
  {
    value: 'RTN',
    text: 'Package Returned',
    number: 7000,
    next: [],
  },
];
const constant = {
  statusList: shipmentStatusList,
  batchStatusList: shipmentBatchStatusList,
};

export default constant;
